var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networkErrorView"},[_c('navBar'),_c('div',{staticClass:"content mt10 mb10 dfcjc"},[_c('div',[_c('img',{attrs:{"src":require("../assets/img/nullnetwork.jpg"),"alt":""}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回首页")])],1)]),_c('footerBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }